import { I18n } from '@app/i18n/strings-keys';

enum COMMON_ACTION_NAMES {
  View = 'View',
  Edit = 'Edit',
  Accept = 'Accept',
  Approve = 'Approve',
  Reject = 'Reject',
  Reopen = 'Reopen',
  SaveAndReopen = 'Save & Reopen',
  Save = 'Save',
  Void = 'Void',
  Print = 'Print',
  PrintWrittenSheet = 'Print Written Sheet',
  Export = 'Export PDF',
  Submit = 'Submit',
  Cancel = 'Cancel',
  Continue = 'Continue',
  CreateNewTransferFromTransferQTY = 'Create New Transfer From Transfer QTY',
  CreateNewTransferFromPhysicalQTY = 'Create New Transfer From Physical QTY',
  AutoRestock = 'Auto Restock',
  NewTemplate = 'New Template',
  Remove = 'Remove',
  SaveAndNew = 'Save and New',
  SubmitAndNew = 'Submit and New',
  Duplicate = 'Duplicate',
}

enum COMMON_ACTION_TYPES {
  View = 'view',
  Edit = 'edit',
  Submit = 'submit',
  Cancel = 'cancel',
  Accept = 'accept',
  Approve = 'approve',
  Reject = 'reject_all',
  Reopen = 'reopen',
  Print = 'print',
  Export = 'export',
  Void = 'void',
  PrintWrittenSheet = 'print_written_sheet',
  Remove = 'remove',
  Duplicate = 'duplicate',
  AssignmentRemove = 'assignment-remove',
}

export const ACTION_NAME_Translations_MAPPING = {
  save: I18n.Common.save,
  submit: I18n.Common.submit,
  cancel: I18n.Common.cancel,
  void: I18n.Common.void,
  accept: I18n.Common.accept,
  reject: I18n.Common.reject,
};

export const STATUS_ACTION_MAPPING = {
  pending: I18n.Status.Submitted,
  save: I18n.Status.Saved,
  canceled: I18n.Status.Canceled,
  completed: I18n.Status.Accepted,
  approve: I18n.Status.Approved,
  rejected: I18n.Status.Rejected,
  void: I18n.Status.Voided,
  complete: I18n.Status.Completed,
  closeOut: I18n.Forms.HawkerSessionForm.CloseOut,
};

export const DID_KEYWORD_MAPPING = {
  submitted: 'submitted',
  saved: 'saved',
  canceled: 'canceled',
  accepted: 'accepted',
  rejected: 'rejected',
};

export const WANT_TO_KEYWORD_MAPPING = {
  submit: 'submit',
  save: 'save',
  cancel: 'cancel',
  accept: 'accept',
  reject: 'reject',
};

export const DID_STATUS_ACTION_MAPPING = {
  submitted: {
    lowerCase: I18n.Status.submitted,
    upperCase: I18n.Status.Submitted,
  },
  saved: {
    lowerCase: I18n.Status.saved,
    upperCase: I18n.Status.Saved,
  },
  canceled: {
    lowerCase: I18n.Status.canceled,
    upperCase: I18n.Status.Canceled,
  },
  accepted: {
    lowerCase: I18n.Status.accepted,
    upperCase: I18n.Status.Accepted,
  },
  rejected: {
    lowerCase: I18n.Status.rejected,
    upperCase: I18n.Status.Rejected,
  },
};

export const BASIC_ACTION_BUTTON = {
  class: 'menuitem',
  visible: false,
};

const COMMON_ACTION_BUTTONS = {
  View: {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Common.View,
    type: COMMON_ACTION_TYPES.View,
  },
  Edit: {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Common.Edit,
    type: COMMON_ACTION_TYPES.Edit,
  },
  Submit: {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Common.Submit,
    type: COMMON_ACTION_TYPES.Submit,
  },
  Reopen: {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Common.Reopen,
    type: COMMON_ACTION_TYPES.Reopen,
  },
  Accept: {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Common.Accept,
    type: COMMON_ACTION_TYPES.Accept,
  },
  Reject: {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Common.Reject,
    type: COMMON_ACTION_TYPES.Reject,
  },
  Void: {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Status.Void,
    type: COMMON_ACTION_TYPES.Void,
  },
  Cancel: {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Common.Cancel,
    type: COMMON_ACTION_TYPES.Cancel,
  },
  Print: {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Common.Print,
    type: COMMON_ACTION_TYPES.Print,
  },
  Export: {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Common.ExportPDF,
    type: COMMON_ACTION_TYPES.Export,
  },
  Remove: {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Common.Remove,
    type: COMMON_ACTION_TYPES.Remove,
  },
  Duplicate: {
    ...BASIC_ACTION_BUTTON,
    name: I18n.Common.Duplicate,
    type: COMMON_ACTION_TYPES.Duplicate,
  },
};

const COMMON_ACTION_TYPES_REJECT = 'reject';

export {
  COMMON_ACTION_NAMES,
  COMMON_ACTION_TYPES,
  COMMON_ACTION_BUTTONS,
  COMMON_ACTION_TYPES_REJECT,
};
